// Persistent left navigation for the sales console (this task's brief:
// "SALES side navigation — currently only a queue"). Rendered ONLY inside
// AppShell when the live session's role is 'sales' (AppShell.jsx decides
// this, mirroring how it already gates AdminNav for 'admin') — an admin
// session never mounts this component, matching AdminNav's own header
// comment on the reverse case. Every route it links to is still
// independently guarded server-side and, in the SPA, by each route's own
// RequireRole — this component's presence is a navigation/UX choice, not a
// security boundary (admin/CLAUDE.md).
//
// Three items, this task's own explicit order: Today, My queue, My
// quotations. Unlike AdminNav, none of these paths risk the "/admin"-prefix
// dev-proxy/Nginx collision AdminNav's own header comment describes — none
// of them start with a reserved prefix — but they still avoid "/sales" as a
// literal segment for the same class of reason (this app already mounts
// its own request-detail route at "/requests/:requestId", not
// "/sales/requests/:requestId").

import { NavLink } from 'react-router-dom';
import { CalendarCheck, ClipboardList, FileText } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext.jsx';
import styles from './SalesNav.module.css';

const ITEMS = [
  { to: '/today', labelId: 'nav.sales.today', Icon: CalendarCheck },
  { to: '/', labelId: 'nav.sales.myQueue', Icon: ClipboardList, end: true },
  { to: '/my-quotations', labelId: 'nav.sales.myQuotations', Icon: FileText },
];

export default function SalesNav() {
  const { t } = useLanguage();

  return (
    <nav className={styles.nav} aria-label={t('nav.sales.myQueue')}>
      <ul className={styles.list}>
        {ITEMS.map(({ to, labelId, Icon, end }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) => `${styles.link} ${isActive ? styles.linkActive : ''}`}
            >
              <Icon size={18} aria-hidden="true" />
              {t(labelId)}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
